export const FETCH_DASHBOARD_DATA_REQUEST = 'FETCH_DASHBOARD_DATA_REQUEST';
export const FETCH_DASHBOARD_DATA_SUCCESS = 'FETCH_DASHBOARD_DATA_SUCCESS';
export const FETCH_DASHBOARD_DATA_FAILURE = 'FETCH_DASHBOARD_DATA_FAILURE';

export const FETCH_OEM_PARTNERS_REQUEST = 'FETCH_OEM_PARTNERS_REQUEST';
export const FETCH_OEM_PARTNERS_SUCCESS = 'FETCH_OEM_PARTNERS_SUCCESS';
export const FETCH_OEM_PARTNERS_FAILURE = 'FETCH_OEM_PARTNERS_FAILURE';

export const SET_SELECTED_OEM_ID = 'SET_SELECTED_OEM_ID';
export const CLEAR_DASHBOARD_DATA = 'CLEAR_DASHBOARD_DATA';
export const CLEAR_DASHBOARD_ERROR = 'CLEAR_DASHBOARD_ERROR';